import moment from '@/moment-gp'

// TODO: Same as user directory ?

export default {
  create( { username, firstName, lastName }, data ) {
    return {
      createdAt:       moment.currentTimeServer('REALTIMEDB'), // When did user join
      username:        username,
      firstName:       firstName, // TODO: Check if aready stored in auth data
      lastName:        lastName,  // TODO: Check if aready stored in auth data
      // TODO: ProfilePic        // TODO: Check if aready stored in auth data
      // academicTitle:  "",
      jobTitle:        "", // "No Job Title",
      birthday:        null, // 1900-12-31
      level:           1,
      cachedGoalcoins: 0,
      profilePic:      data.profilePic || "", // TODO: User auth instead
      bugbounty: { // Allow transactions, "cached"? -> store real values in readonly
        /* '🐛' : 0 */
      },
      // deleted: false,  ??
      /*
      birthdayDate: // TODO --> moment
        status !== undefined && status.birthday
          ? new Date(status.birthday * 1000)
          : "",
       */
    }
  },

  fields: {
    createdAt: { validate_bolt_type: 'ServerTimestamp' },
    username: { validate_bolt_type: 'String' },
    firstName: { validate_bolt_type: 'String' },
    lastName: { validate_bolt_type: 'String' },
    academicTitle: { validate_bolt_type: 'String' },
    jobTitle: { validate_bolt_type: 'String' },
    birthday: { validate_bolt_type: 'Timestamp' }, // TODO: This won't work for birthday before 1976
    level: { validate_bolt_type: 'Number' },
    cachedGoalcoins: { validate_bolt_type: 'Number' },
    profilePic: { validate_bolt_type: 'String' },
    bugbounty: {},
    '/^bugbounty/.{1,2}$/': { validate_bolt_type: 'Number' },
  }
};
